import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

const ReportJobSummaryByProductGroupData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                setLoading(false);
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["startDate"];
        setErrors(error);
        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["endDate"];
        setErrors(error);
        setEndDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date is required";
        }

        if (!endDate) {
            formIsValid = false;
            errorList["endDate"] = "End Date is required";
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date must be < End Date";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const token = await authService.getAccessToken();

        axios("api/Report/ExportReportJobSummaryByProductGroupData?StartDate=" + startDate + "&EndDate=" + endDate, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "JobSummaryByProductGroup.xlsx");
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Job Summary by Product Group</h1>
            </div>
            <div className="marginTop20">
                <span>Select a Start Date and End Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportJobSummaryByProductGroupData;